/**
 * Normalises a date string from the backend.
 * SQL Server returns UTC timestamps without the 'Z' suffix, so we append it
 * to ensure JavaScript parses them as UTC rather than local time.
 */
function toDate(dateStr: string): Date {
  const utcStr = dateStr.endsWith('Z') ? dateStr : dateStr + 'Z';
  return new Date(utcStr);
}

/** Returns a date string formatted as DD/MM/YYYY in the user's local timezone. */
export function formatDate(dateStr: string): string {
  const d = toDate(dateStr);
  const day   = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year  = d.getFullYear();
  return `${day}/${month}/${year}`;
}

/** Returns a datetime string formatted as DD/MM/YYYY HH:mm:ss in the user's local timezone. */
export function formatDateTime(dateStr: string): string {
  const d = toDate(dateStr);
  const day     = String(d.getDate()).padStart(2, '0');
  const month   = String(d.getMonth() + 1).padStart(2, '0');
  const year    = d.getFullYear();
  const hours   = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}
